import { useNavigate } from "react-router-dom";
import pricesData from "./prices.json";
import Rate from "./Rate";
import RatesInfoBox from "./RatesInfoBox";

const RatesList = ({t}) => {
  const navigate = useNavigate();

  const ratesData = Object.values(t("pages.rates.options", { returnObjects: true })).map(rate => ({
    id: rate.id,
    dbId: rate.dbId,
    duration: rate.duration,
    price: rate.price,
    description: rate.description,
    detailedDescription: rate.detailedDescription,
    to: rate.to,
    logo: rate.logo,
    showActionContainer: rate.showActionContainer
  }));

  return (
    <>
        <RatesInfoBox text={t("pages.rates.texts.text2")} />
        <div className="generic-list">
            {ratesData.map((rate, index) => (
                <Rate 
                  key={index}
                  id={rate.id}
                  logo={rate.logo}
                  title={rate.duration} 
                  description={rate.description}
                  price={(pricesData[rate.dbId] || "-") + rate.price}
                  detailedDescription={getDetailedDescription(pricesData, rate.dbId, rate.detailedDescription)}
                  buttonInfo={t("pages.rates.texts.text2", { returnObjects: true })}
                  onClick={() => {navigate(rate.to)}}
                />
            ))}
        </div>
        {/*         
        <div className="generic-separator"/>
        <div className="generic-list-description">
            {ratesData.map((rate, index) => (
            <div id={"description-" + rate.id} key={rate.id}>
                <RateDescription 
                    title={rate.duration} 
                    price={(pricesData[rate.dbId] || "-") + rate.price} 
                    description={getDetailedDescription(pricesData, rate.dbId, rate.detailedDescription)}
                    showBottomBorder={!(index === ratesData.length - 1)}
                    onButtonClick={() => {navigate(rate.to)}}
                    buttonInfo={t("pages.rates.texts.text1", { returnObjects: true })}
                    showActionContainer={rate.showActionContainer}
                />
            </div>
            ))}
        </div>
        */}
    </>
  );
};

export default RatesList;

const getDetailedDescription = (prices, dbId, detailedDescription) => {
  let updatedDetailedDescription = detailedDescription;
  if (dbId === "hday") {
    const hourRateValue = prices["hour"] || "-";
    updatedDetailedDescription = detailedDescription.replace('%hourRate%', hourRateValue)
  }
  return updatedDetailedDescription;
}